// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"75e50e41","356":"ee236949","927":"947d51ee"}[chunkId] + ".chunk.css";
};